import { useGetPlayerEventsV1DsQuery } from "../../../core/api/ds-player-events-api"
import PlayerEventsDialog from "../common/PlayerEventsDialog"
import PlayerEventsPage from "../common/PlayerEventsPage"
import { initialQuickLookSettings } from "./DsPlayerEventsConstants"

const PlayerEvents = () => (
    <PlayerEventsPage
        useQuery={useGetPlayerEventsV1DsQuery}
        storageKey="ds_quick_look_settings"
        initialSettings={initialQuickLookSettings}
        typeField="eventType"
        typeHeaderName="Event Type"
        DialogComponent={PlayerEventsDialog}
    />
)

export default PlayerEvents
